import { produce } from '@/globals/helpers/immer';
import { ValuesByDimension } from '../lineGraph.types';

export const getDimensionDataProperties = ({
	dimensionKey,
	valuesByDimension,
}: {
	dimensionKey: string;
	valuesByDimension: ValuesByDimension;
}) => {
	const valueObject = valuesByDimension[dimensionKey];
	const valueList = Object.values(valueObject);

	const dataProperties = valueList.reduce(
		(memo, value) => {
			if (typeof value !== 'number') {
				return memo;
			}

			const nextMemo = produce(memo, (draft) => {
				draft.total += value;
				draft.length += 1;
				return;
			});

			if (value < 0) {
				const min = Math.min(value, nextMemo.min);
				return { ...nextMemo, min };
			}

			const max = Math.max(value, nextMemo.max);
			return { ...nextMemo, max };
		},
		{ min: 0, max: 0, total: 0, length: 0 },
	);

	const { total, length } = dataProperties;

	return {
		...dataProperties,
		average: length > 0 ? total / length : undefined,
	};
};
